/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IRequiredEquipment {
  Dumbbells = 'Dumbbells',
  ResistanceBands = 'Resistance Bands',
  MedicineBall = 'Medicine Ball',
  ExerciseBall = 'Exercise Ball',
  Kettlebell = 'Kettlebell',
  Mat = 'Mat',
}
